import React from "react";

import BackIcon from "../../../../assets/svg/BackIcon";
import { useNavigate } from "react-router-dom";
import Header from "../../../../containers/Header";
import BeforeLoginFooter from "../../../../containers/BeforeLoginFooter";

function BeforeBonusTerms() {
  const navigate = useNavigate();

  return (
    <>
      <Header />

      <main className="main static-page">
        <div className="container">
          <div className="headingSec">
            <h4> Bonus Terms & Conditions</h4>
            <div className="back-link" onClick={() => navigate(-1)}>
              <BackIcon /> Back
            </div>
          </div>
          <div className="content">
            <h5> Deposit Bonus Tiers</h5>
            <table className="mt-3">
              <tr>
                <th>Deposit Amount</th>
                <th>Bonus %</th>
                <th>Bonus Value</th>
                <th>Total Playing Balance</th>
              </tr>
              <tr>
                <td>$ 25</td>
                <td>No Bonus</td>
                <td>$0</td>
                <td>$25</td>
              </tr>
              <tr>
                <td>$ 50</td>
                <td>25%</td>
                <td>$ 12.50</td>
                <td>$ 62.50</td>
              </tr>
              <tr>
                <td>$ 100</td>
                <td>50%</td>
                <td>$ 50</td>
                <td>$ 150</td>
              </tr>
              <tr>
                <td>$ 200</td>
                <td>100%</td>
                <td>$ 200</td>
                <td>$ 400</td>
              </tr>
              <tr>
                <td>$ 300+</td>
                <td>300%</td>
                <td>$ 900</td>
                <td>$ 1200 +</td>
              </tr>
            </table>

            <h5> Bonus Terms & Conditions</h5>

            <p className="privacy-points">
              1. Wagering Requirement: All bonuses are subject to 30× wagering
              of the bonus amount before withdrawal is possible.
            </p>
            <p className="privacy-points">
              2. Maximum Bet While Wagering: You may not place bets higher than
              $5 while wagering an active bonus.
            </p>
            <p className="privacy-points">
              3. Game Contribution Toward Wagering :-
              <ul>
                <li> - Slots: 100%</li>
                <li> - Live Casino/Table Games: 10%</li>
                <li>- Jackpot Games: 0%</li>
              </ul>
            </p>
            <p className="privacy-points">
              4. Bonus Validity: All bonuses expire 7 days after being credited.
              Free spins expire in 24 hours.
            </p>
            <p className="privacy-points">
              5. Bonus Abuse: Using multiple accounts, VPNs, or abusive
              strategies will lead to forfeiture and ban.
            </p>
            <p className="privacy-points">
              6. Withdrawal Rules: If you withdraw before meeting the wagering
              requirement, the bonus and winnings are forfeited.
            </p>
            <p className="privacy-points">
              7. Maximum Win Cap: You may withdraw a maximum of 5× the bonus
              amount won through bonus play.
            </p>
          </div>
        </div>
      </main>

      <BeforeLoginFooter />
    </>
  );
}

export default BeforeBonusTerms;
